import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { RouteInfo,ChildrenItems } from './../../_models/Portal/Menu'


@Injectable({
  providedIn: 'root'
})

export class PortalService {

  constructor(private http: HttpClient) { }


  getMenuByRole(role: string){
    return this.http.get<RouteInfo[]>(`${environment.apiUrl}/api/Portal/Menu/${role}`);
}

}
